{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Live chat campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "CARD": {
        "STATUS": {
          "ENABLED": "Leisti",
          "DISABLED": "Išjungta"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Siuntėjas",
          "BOT": "Botas",
          "FROM": "nuo",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No live chat campaigns are available",
        "SUBTITLE": "Connect with your customers using proactive messages.  Click 'Create campaign' to get started."
      },
      "CREATE": {
        "TITLE": "Create a live chat campaign",
        "CANCEL_BUTTON_TEXT": "Atšaukti",
        "CREATE_BUTTON_TEXT": "Sukurti",
        "FORM": {
          "TITLE": {
            "LABEL": "Pavadinimas",
            "PLACEHOLDER": "Įveskite akcijos pavadinimą",
            "ERROR": "Yra reikalingas pavadinimas"
          },
          "MESSAGE": {
            "LABEL": "Žinutė",
            "PLACEHOLDER": "Įveskite akcijos pranešimą",
            "ERROR": "Yra reikalingas pranešimas"
          },
          "INBOX": {
            "LABEL": "Pasirinkti gautų laiškų aplanką",
            "PLACEHOLDER": "Pasirinkti gautų laiškų aplanką",
            "ERROR": "Yra reikalingas gautų laiškų aplankas"
          },
          "SENT_BY": {
            "LABEL": "Siuntėjas",
            "PLACEHOLDER": "Please select sender",
            "ERROR": "Yra reikalingas siuntėjas"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Prašome įvesti URL adresą",
            "ERROR": "Prašome įvesti tesingą URL adresą",
            "URL_IS_REGEXP": "Reikšmė yra reguliarioji išraiška"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Laikas puslapyje (sekundės)",
            "PLACEHOLDER": "Prašome įvesti laiką",
            "ERROR": "Nurodykite laiką puslapyje"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Other preferences",
            "ENABLED": "Leisti akciją",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Aktyvuokite tik darbo valandomis"
          },
          "BUTTONS": {
            "CREATE": "Sukurti",
            "CANCEL": "Atšaukti"
          },
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign created successfully",
            "ERROR_MESSAGE": "Įvyko klaida. Prašau, pabandykite dar kartą."
          }
        }
      },
      "EDIT": {
        "TITLE": "Edit live chat campaign",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign updated successfully",
            "ERROR_MESSAGE": "Įvyko klaida. Prašau, pabandykite dar kartą."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No SMS campaigns are available",
        "SUBTITLE": "Launch an SMS campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "Užbaigta",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create SMS campaign",
        "CANCEL_BUTTON_TEXT": "Atšaukti",
        "CREATE_BUTTON_TEXT": "Sukurti",
        "FORM": {
          "TITLE": {
            "LABEL": "Pavadinimas",
            "PLACEHOLDER": "Įveskite akcijos pavadinimą",
            "ERROR": "Yra reikalingas pavadinimas"
          },
          "MESSAGE": {
            "LABEL": "Žinutė",
            "PLACEHOLDER": "Įveskite akcijos pranešimą",
            "ERROR": "Yra reikalingas pranešimas"
          },
          "INBOX": {
            "LABEL": "Pasirinkti gautų laiškų aplanką",
            "PLACEHOLDER": "Pasirinkti gautų laiškų aplanką",
            "ERROR": "Yra reikalingas gautų laiškų aplankas"
          },
          "AUDIENCE": {
            "LABEL": "Auditorija",
            "PLACEHOLDER": "Pažymėti klieto etiketes",
            "ERROR": "Reikalinga auditorija"
          },
          "SCHEDULED_AT": {
            "LABEL": "Suplanuotas laikas",
            "PLACEHOLDER": "Prašau pasirinkti laiką",
            "ERROR": "Būtinas suplanuotas laikas"
          },
          "BUTTONS": {
            "CREATE": "Sukurti",
            "CANCEL": "Atšaukti"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS campaign created successfully",
            "ERROR_MESSAGE": "Įvyko klaida. Prašau, pabandykite dar kartą."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Ar tikrai norite ištrinti?",
      "DESCRIPTION": "The delete action is permanent and cannot be reversed.",
      "CONFIRM": "Ištrinti",
      "API": {
        "SUCCESS_MESSAGE": "Akcija ištrinta sėkmingai",
        "ERROR_MESSAGE": "Įvyko klaida. Prašau, pabandykite dar kartą."
      }
    }
  }
}
